import React from 'react';
import styles from "./List.module.css";
import BtnSwitch from "../Button/BtnSwitch";
import stylesSwitch from '../Button/BtnSwitch.module.css';

const ListSwitch = ({ listData, handleToggleSwitch, title, description }) => {
    return (
        <div className={"blocContainer"}>
            <h3 className={styles.listSwitchTitle}>{title}</h3>
            <p className={styles.listSwitchDescription}>{description}</p>

            <ul className={styles.listSwitch}>
                {listData.map(item => (
                    <li className={styles.liSwitch} key={item.key}>
                        <span className={styles.listLabel}>{item.name} </span>
                        <BtnSwitch
                            active={item.isSwitchActive}
                            activeLabel={item.userRegisteredLabel}
                            inactiveLabel={item.userNonRegisteredLabel}
                            onToggle={() => handleToggleSwitch(item.key)}
                            id={`switch-${item.key}`}
                            name={`switch-${item.name}`}
                            classNames={stylesSwitch.sliderList}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ListSwitch;
